import React, { useEffect, useRef, useState } from 'react';
import Tree from 'react-d3-tree';
import { Button, Spinner } from 'react-bootstrap';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { getTreeDataById } from '../redux/slicess/leaderTreeSlice';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { commonService } from '../services/common.services';
import { apiConstants } from '../constant/api.constant';
import { throttle } from 'lodash';
import { color } from 'framer-motion';
import Dashboardheader from '../directives/dashboardheader';
import { TbBusinessplan } from "react-icons/tb";
import { MdOutlineBusinessCenter } from "react-icons/md";

// Styles
const useStyles = makeStyles(() =>
  createStyles({
    button: {
      color: '#fff',
      width: 130,
      height: 130,
      textAlign: 'center',
      marginLeft: 40,
      border: '4px solid red !important',
      overflow: 'hidden',
      background: 'linear-gradient(90deg, rgb(15 69 86) 0%, rgb(35 12 83) 47.4%, rgb(83 15 98) 96.19%)',
      borderRadius: 20,
      '& > span': {
        flexFlow: 'column',
      },
      '&:hover': {
        color: '#fff',
        background: 'linear-gradient(90deg, rgb(15 69 86) 0%, rgb(35 12 83) 47.4%, rgb(83 15 98) 96.19%)',
      },
    },
    greenButton: {
      color: '#fff',
      width: 130,
      height: 130,
      textAlign: 'center',
      marginLeft: 40,
      border: '4px solid #28ff28 !important',
      overflow: 'hidden',
      background: 'linear-gradient(90deg, rgb(15 69 86) 0%, rgb(35 12 83) 47.4%, rgb(83 15 98) 96.19%)',
      borderRadius: 20,
      '& > span': {
        flexFlow: 'column',
      },
      '&:hover': {
        color: '#fff',
      },
    },
    goldButton: {
      color: '#fff',
      width: 130,
      height: 130,
      textAlign: 'center',
      marginLeft: 40,
      border: '4px solid gold !important',
      overflow: 'hidden',
      background: 'linear-gradient(90deg, rgb(15 69 86) 0%, rgb(35 12 83) 47.4%, rgb(83 15 98) 96.19%)',
      borderRadius: 20,
      '& > span': {
        flexFlow: 'column',
      },
      '&:hover': {
        color: 'white',
        backgroundColor: "#EFBF04"
      },
    },
    name: {
      fontSize: 16,
    },
    attributes: {
      marginTop: 0,
    },
  })
);


const MlmTree = () => {
  const classes = useStyles();
  const treeContainerRef = useRef(null);
  const dispatch = useDispatch()
  const leaderTreeData = useSelector((state) => state.LeaderTree);
  const [isLoading, setIsLoading] = useState(false)

  const [translate, setTranslate] = useState({ x: 0, y: 0 });
  const [dimensions, setDimensions] = useState(undefined);
  const [hoveredNode, setHoveredNode] = useState(null);
  const [hoverPos, setHoverPos] = useState({ x: 0, y: 0 });

  const nodeSize = { x: 300, y: 300 };
  const foreignObjectProps = { width: nodeSize.x, height: nodeSize.y, x: -105 };

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
      Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
    );

  const [treeData, setTreeData] = useState({
    id: null,
    name: null,
    collapsed: false,
    color: null,
    hover_card: null,
    children: [],
  });

  useEffect(() => {
    dispatch(getTreeDataById({ id: loginData.id }));
  }, [dispatch])


  const getTreeChildDataByIdData = async (id) => {
    const response = await commonService.getWithToken(apiConstants.GET_LEADERCHILDTREENODE, { id: id });
    return response
  };

  useEffect(() => {
    if (leaderTreeData && leaderTreeData.leaderTreeData && leaderTreeData.leaderTreeData) {
      setTreeData((prevTreeData) => ({
        id: leaderTreeData.leaderTreeData.id,
        name: leaderTreeData.leaderTreeData.name,
        collapsed: leaderTreeData.leaderTreeData.collapsed,
        color: leaderTreeData.leaderTreeData.color,
        hover_card: leaderTreeData.leaderTreeData?.hover_card,
        children: leaderTreeData.leaderTreeData?.result,
      }));
      setIsLoading(leaderTreeData.loading)
    }
  }, [leaderTreeData])


  const markNodesWithNewBusiness = (node) => {
    let hasNewBusiness = false;

    // Check current node
    if (parseInt(node?.hover_card?.today_business || '0', 10) > 1) {
      hasNewBusiness = true;
    }

    // Check children
    if (node.children) {
      node.children = node.children.map(child => {
        const updatedChild = markNodesWithNewBusiness(child);
        if (updatedChild.hasNewBusiness) {
          hasNewBusiness = true;
        }
        return updatedChild;
      });
    }
    return { ...node, hasNewBusiness };
  };

  const handleNodeClick = throttle(async (nodeId, node) => {
    if (node.color === 0) {
      return
    }
    const resultResponses = await getTreeChildDataByIdData(nodeId);
    const addNewChild = (node) => {
      if (node.id === nodeId) {
        return {
          ...node,
          collapsed: !node.collapsed,
          children: !node.collapsed
            ? [...resultResponses.data[0].result]
            : [],
        };
      }
      return {
        ...node,
        children: node.children.map(addNewChild),
      };
    };

    setTreeData((prevTreeData) => addNewChild(prevTreeData));
  }, 300);

  // Collapse the tree from a certain depth
  const collapseTree = (node, currentDepth = 0, collapseFromDepth = 2) => {
    const newNode = { ...node };

    if (newNode.children) {
      newNode.children = newNode.children.map((child) =>
        collapseTree(child, currentDepth + 1, collapseFromDepth)
      );

      if (currentDepth >= collapseFromDepth - 1) {
        newNode._collapsed = true;
      }
    }

    return newNode;
  };

  useEffect(() => {


    if (treeContainerRef.current) {
      const { width, height } = treeContainerRef.current.getBoundingClientRect();
      setTranslate({ x: width / 2, y: 225 });
      setDimensions({ width, height });
    }
  }, []);
  const renderNode = ({ nodeDatum, toggleNode }) => (
    <foreignObject {...foreignObjectProps}>
      <Button
        className={nodeDatum.color === 1 ? classes.greenButton : nodeDatum.color === 0 ? classes.button : nodeDatum.color === 2 ? classes.goldButton : classes.button}
        variant="contained"

        onClick={() => handleNodeClick(nodeDatum.id, nodeDatum)}
        onMouseOver={(e) => {
          setHoveredNode(nodeDatum);
          setHoverPos({ x: e.clientX, y: e.clientY });
        }}
        onMouseMove={(e) => {
          setHoverPos({ x: e.clientX + 40, y: e.clientY - 130 });
        }}
        onMouseOut={() => setHoveredNode(null)}
      >
        <div className={classes.attributes}>
          <img
            src="assets/images/userIcon.png"
            alt="Profile"
            width="50%"
            height="38px"
            style={{ objectFit: 'contain', marginBottom: 10 }}
          />
        </div>
        <div className={classes.name}>{nodeDatum.name}</div>
      </Button>
    </foreignObject>
  );

  return (
    <>
      <Dashboardheader />

      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>
        {
          isLoading ? <div style={{ height: '90vh'}} className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div> : <> <div style={{ height: '90vh', position: 'relative', overflow: "hidden" }} ref={treeContainerRef}>
            <div className='' style={{ position: "absolute", bottom: "10%", right: 40 }}>


              <div className='d-flex gap-2 align-items-center text-white' style={{ fontSize: 12 }}>
                <div className='mlm-red-box'></div>
                Indicates an inactive business.
              </div>
              <div className='d-flex gap-2 align-items-center text-white' style={{ fontSize: 12 }}>
                <div className='mlm-green-box'></div>
                Indicates an active business.
              </div>
              <div className='d-flex gap-2 align-items-center text-white' style={{ fontSize: 12 }}>
                <div className='mlm-golden-box'></div>
                Indicates newly generated business.
              </div>

            </div>

            {treeData && (
              <Tree
                data={treeData}
                translate={translate}
                nodeSize={nodeSize}
                transitionDuration={1000}
                pathFunc="step"
                orientation="vertical"
                collapsible
                zoomable
                zoom={0.5}
                draggable
                shouldCollapseNeighborNodes={false}
                renderCustomNodeElement={renderNode}
                onNodeClick={handleNodeClick}
                getNodeClassName="link-type-b"
              />
            )}
            {hoveredNode && (
              <div
                style={{
                  position: 'absolute',
                  top: hoverPos.y + 10,
                  left: hoverPos.x + 10,
                  padding: 12,
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  zIndex: 1000,
                  minWidth: 130,
                  pointerEvents: 'none',

                }}
                className='tree-div'
              >


                <div className="d-flex align-items-center gap-2 pb-1" style={{ borderBottom: "1px solid #ffffff20" }}>
                  <MdOutlineBusinessCenter /><p className='mb-0 text-light'>Total Business :</p>
                  <p className="mb-0 text-light">{hoveredNode.hover_card?.total_business || "00"}</p>
                </div>
                <div className="d-flex align-items-center gap-2 mt-1">
                  <TbBusinessplan /><p className='mb-0 text-light'>New Business :</p>
                  <p className="mb-0 text-light" >{hoveredNode.hover_card?.today_business || "00"}</p>
                </div>
              </div>
            )}
          </div></>
        }

      </div>
    </>
  );
};

export default MlmTree;
